export default {
  listaAlertas: []
}
